import { ADMIN_OR_ABOVE } from "@excel-center/shared";
import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { DASHBOARD_ROUTES } from "@/src/dashboard/constants/dashboard-routes.constants";

const DashboardPage = lazy(() => import("@/src/dashboard/pages/dashboard.page"));

/**
 * Dashboard routes (mounted under `AuthedLayout` → `ProtectedRoute`).
 * Admin-and-up only: general staff and students have no dashboard.
 */
export const dashboardRoutes: RouteObject[] = [
	{
		path: DASHBOARD_ROUTES.dashboard,
		element: (
			<ProtectedRoute requiredRole={[...ADMIN_OR_ABOVE]}>
				<DashboardPage />
			</ProtectedRoute>
		),
	},
];
